import { atom } from "recoil";
import { PhoneVerificationProps } from "./phone-verification-props";

export const phoneVerificationState = atom<PhoneVerificationProps | null>({
  key: "phoneVerificationState",
  default: {
    phone: "",
  },
});
